<template>
  <base-form :can-back="canBack">
    <slot />
    <template #expansion-buttons-right>
      <slot name="expansion-buttons-right" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'

export default {
  name: "DownloadForm",
  components: {
    BaseForm,
  },
  props: {
    canBack: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
